export enum RolesIdsEnum {
    Comprador = 1,
    DonoDaOficina = 2,
    Vendedor = 4,
    VendedorCommerce = 5,
    GestorDeLoja = 8,
    GestorDePecas = 16,
    Suporte = 32,
    Faturamento = 33,
    Central = 34,
    CentralSuporte = 35,
    Comercial = 36,
    GestorFaturamento = 37,
    SuporteSuperAdmin = 38,
    SupervisorOficina = 64
}
